import _ from 'lodash';
import { dialog } from '$gcomponents/reusables';
import intl, { checkKeyFormat } from '$gintl';
import { SORT } from '../enums';
import { AMEX, DISCOVER, MASTERCARD, VISA } from '../enums/cardTypes';
import { ASC, DSC } from '../enums/sort';
import { SideMenuModel } from '../models/sideMenu';
import { getStorageObj } from '../services/local.storage';
import { getEl } from './input';

export const clog = (...items) => {
  if (process.env.REACT_APP_ENV !== 'prod') {
    console.log(...items);
  }
};

export const mergeObjectStrict = (obj1 = {}, obj2 = {}) => {
  const obj = { ...obj1 };
  for (const key in obj) {
    if (obj2[key] !== undefined) obj[key] = obj2[key];
  }
  return obj;
};

export const itemText = (action: string, item: string) => {
  return intl('ITEM.' + action.toUpperCase(), {
    item: checkKeyFormat(item) ? intl('COMMON.' + item.toUpperCase()) : item,
  });
};

export const leadingZero = (number, digits) => {
  const zeros = Array(digits).fill(0).join('');
  return (zeros + number).slice(-4);
};

export const accessString = (accessLevel, feature = '') => {
  const accessClass =
    accessLevel === undefined || accessLevel === null ? '' : `access_${accessLevel.toString()}`;
  const featureClass = feature ? `feature_${feature}` : '';
  return `${accessClass} ${featureClass}`;
};

export const canAccess = (accessLevel, userLevel) => {
  if (accessLevel === undefined || accessLevel === null) return true;
  if (accessLevel === 0 || accessLevel) {
    if (userLevel <= accessLevel) return true;
  }
  return false;
};

export const hasFeature = async (feature) => {
  const localFeatures = await getStorageObj('features');
  // const appFeature = document.body.classList.contains(`body_${feature}`);
  console.log('LOCAL FEATURES', localFeatures[feature]);
  if (localFeatures[feature]) return true;
  return false;
};

export const toFileSize = (number) => {
  if (isNaN(number) || number == null) return '';
  if (number >= 1000000000000) return `${(number / 1000000000000).toFixed(2)} TB`;
  if (number >= 1000000000) return `${(number / 1000000000).toFixed(2)} GB`;
  if (number >= 1000000) return `${(number / 1000000).toFixed(2)} MB`;
  if (number >= 1000) return `${(number / 1000).toFixed(2)} KB`;
  return `${number} B`;
};

export const sleep = (m) => new Promise((r) => setTimeout(r, m));

export const changeSort = (order) => (order === DSC ? ASC : DSC);

export const intToArray = (number) =>
  Array(number)
    .fill(1)
    .map((v, i) => i);

export const rangeToArray = (start, end) => {
  if (start > end) return [];
  const diff = end - start + 1;
  return Array(diff)
    .fill(1)
    .map((v, i) => start + i);
};

export const flattenObject = (obj) => {
  return Object.assign(
    {},
    ...(function _flatten(o) {
      return [].concat(
        ...Object.keys(o).map((k) => (typeof o[k] === 'object' ? _flatten(o[k]) : { [k]: o[k] })),
      );
    })(obj),
  );
};

export const popPlaceholder = (text = '') => {
  dialog.alert({
    title: 'MESSAGE.SORRY',
    message: 'MESSAGE.FEATURE_NOT_READY',
    ...(text && { text }),
    key: { name: 'Supercalifrgerlisticexplialidocous' },
  });
};

export const sortArray = (data, key, order) => {
  if (!key) return data;
  const temp = [...data];
  temp.sort((a, b) => {
    const valA = _.get(a, key);
    const valB = _.get(b, key);

    if (valA === valB && a.id && b.id) {
      return a.id - b.id;
    }

    return order === SORT.ASC
      ? valA > valB
        ? 1
        : valB > valA
        ? -1
        : 0
      : valA < valB
      ? 1
      : valB < valA
      ? -1
      : 0;
  });
  return temp;
};

export const mirrorObjKeys = (obj) => {
  const newObj = {};
  for (let i in obj) {
    newObj[i] = i;
  }
  return newObj;
};

export const getStyleColor = (color, colorType = '') => {
  return `var(--ion-color-${color}${colorType ? `-${colorType}` : ''})`;
};

export const addMinutesToTimestamp = (seconds, timestamp = 0) => {
  const now = timestamp || +new Date();

  return now + seconds * 1000;
};

export const getLast4 = (str) => {
  if (!str) return '';
  if (str.length > 4) return str.toString().substr(-4);
  return str;
};

export const getCardType = (str) => {
  if (!str) return '';
  switch (str[0] || '') {
    case '3':
      return AMEX;
    case '4':
      return VISA;
    case '5':
      return MASTERCARD;
    case '6':
      return DISCOVER;
    default:
      return '';
  }
};

export const randomInt = (min, max) => {
  return parseInt(Math.floor(Math.random() * (max - min + 1)) + min);
};

export const createUuid = () => {
  var dt = new Date().getTime();
  var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (dt + Math.random() * 16) % 16 | 0;
    dt = Math.floor(dt / 16);
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
  return uuid;
};

export const percentage = (amount, decimal = 1) => Number(amount).toFixed(decimal) + '%';

export const currency = (amount, shouldRound = false) => intl('PRICE', { amount: amount || 0 });

export const dollar = (amount, useDecimal = true) => {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    ...(!useDecimal && { maximumFractionDigits: 0 }),
  });

  return formatter.format(amount);
};

export const currencyAuto = (amount, thres = 3) => {
  return amount % 1 === 0 && amount > 10 ** thres ? dollar(amount, false) : currency(amount);
};

export const getCardPathFromType = (cardType) => {
  return `/assets/img/${cardType.toLowerCase()}_icon.png`;
};

export const getDefaultCardId = (cards) => {
  const card = cards.find((c) => c.isDefault);
  if (!card) return 0;
  return card.cardId;
};

export const getCardPath = (cardNumber) => {
  let fileName;
  switch (cardNumber[0] || '') {
    case '3':
      fileName = 'amex';
      break;
    case '4':
      fileName = 'visa';
      break;
    case '5':
      fileName = 'mastercard';
      break;
    case '6':
      fileName = 'discover';
      break;
    default:
      fileName = 'card';
      break;
  }
  return `/assets/img/${fileName}_icon.png`;
};

export const parseAddress = (add) => {
  if (!add || !add?.length) return '';

  const tmp = add.split(',');
  let street;
  if (tmp.length <= 1) return add;

  street = tmp[0];
  if (tmp.length === 2) {
    return {
      street,
      zip: tmp[1],
    };
  }
  if (tmp.length > 2) {
    const tmp2 = tmp[2].trim().split(' ');
    return {
      street,
      city: tmp[1] || '',
      state: tmp2[0] || '',
      zip: tmp2[1] || '',
    };
  }

  return add;
};

export const roundDecimal = (num, decimal = 2): number => {
  // Convert to string to avoid floating-point precision issues
  const numStr = num.toString();

  // Find decimal point
  const decimalIndex = numStr.indexOf('.');

  // If no decimal point, return the number as-is
  if (decimalIndex === -1) {
    return Number(num);
  }

  // If already has fewer or equal decimal places than requested, return as-is
  if (numStr.length - decimalIndex - 1 <= decimal) {
    return Number(num);
  }

  // Get the digit at the position we want to round
  const roundingDigit = parseInt(numStr[decimalIndex + decimal + 1]);

  // Create the truncated number string
  const truncatedStr = numStr.substring(0, decimalIndex + decimal + 1);
  let result = parseFloat(truncatedStr);

  // If the rounding digit is 5 or greater, round up
  if (roundingDigit >= 5) {
    const increment = Math.pow(10, -decimal);
    result += increment;
  }

  // Fix any floating-point precision issues in the final result
  return parseFloat(result.toFixed(decimal));
};

export const floorDecimal = (num, decimal = 2) => {
  const multiplier = 10 ** decimal;
  return Math.floor(num * multiplier) / multiplier;
};

export const toNumber = (str) => {
  if (!str) return 0;
  return Math.round(Number(str.toString().replace(/,/g, '')) * 100) / 100;
};

/**
 * Pure function that checks if a number has 5 or more decimal places
 * @param num - The number to check
 * @returns Boolean indicating if the number has 5 or more decimal places
 */
export const hasDecimalFiveOrGreater = (num: number): boolean => {
  if (typeof num !== 'number' || !isFinite(num)) {
    return false;
  }

  // Convert to string to count decimal places
  const numStr = num.toString();

  // Check if there's a decimal point
  const decimalIndex = numStr.indexOf('.');
  if (decimalIndex === -1) {
    return false; // No decimal places
  }

  // Count decimal places
  const decimalPlaces = numStr.length - decimalIndex - 1;

  return decimalPlaces >= 5;
};

export const joinAddress = (address) => {
  if (!address) return '';
  const { city, state, zip } = address;
  if (city && state) return `${city || ''}, ${state || ''} ${zip || ''}`;
  return zip;
};

export const formatAddress = (address, delim = '<br>') => {
  if (!address) return address;
  return address.replace(', ', delim);
};

export const replaceAll = (str, mapObj) => {
  var re = new RegExp(Object.keys(mapObj).join('|'), 'gi');

  return str.replace(re, function (matched) {
    return mapObj[matched.toLowerCase()];
  });
};

export const getPublicFactoryId = () => {
  return process.env.REACT_APP_FACTORY_ID;
};

export const generateGetParam = (initialParam) => {
  const factoryId = getPublicFactoryId();
  const param = {
    ...(!initialParam ? {} : initialParam),
    ...(factoryId && { factoryId }),
  };
  return new URLSearchParams(param).toString();
};

export const getInitial = (input: string): string => {
  if (!input) return '';

  const words = input.trim().split(/\s+/);

  // Helper to get the first alphanumeric character of a word
  const getAlphanumericInitial = (word: string): string => {
    const match = word.match(/[a-zA-Z0-9]/);
    return match ? match[0].toUpperCase() : '';
  };

  if (words.length === 1) {
    return getAlphanumericInitial(words[0]);
  }

  const firstInitial = getAlphanumericInitial(words[0]);
  const lastInitial = getAlphanumericInitial(words[words.length - 1]);

  return firstInitial + lastInitial;
};

export const focusInputEl = async (selector, timeout) => {
  await sleep(timeout);
  const el: any = getEl(selector);
  if (el) {
    el.select();
    el.focus();
  }
};

export const onPressEnter = (e, value, onEnter) => {
  const charCode = e.which ? e.which : e.keyCode;
  if (charCode === 13 && onEnter) {
    onEnter(value);
  }
};

export const getSideMenu = (route): SideMenuModel => {
  return {
    title: route.title,
    ...(route.icon && { icon: route.icon }),
    ...(isUrl(route.path)
      ? { href: route.path }
      : route.path && {
          path: `${route.path}${route.defaultId ? '/' + route.defaultId : ''}`,
        }),
    ...(route.component && { route: route }),
    ...(route.routes && {
      submenu: route.routes.map((r) => getSideMenu(r)),
    }),
  };
};

export const isUrl = (string) => {
  let url;

  try {
    url = new URL(string);
  } catch (_) {
    return false;
  }

  return url.protocol === 'http:' || url.protocol === 'https:';
};

export const filterObjProps = (obj, props) => {
  return Object.keys(obj).reduce((acc, key) => {
    if (props.includes(key)) acc[key] = obj[key];
    return acc;
  }, {});
};

export const download = (path, filename) => {
  // Create a new link
  const anchor = document.createElement('a');
  anchor.href = path;
  anchor.download = filename;

  // Append to the DOM
  document.body.appendChild(anchor);

  // Trigger `click` event
  anchor.click();

  // Remove element from DOM
  document.body.removeChild(anchor);
};

export const removeProp = (originalObj, propName = undefined) => {
  const obj = { ...originalObj };
  for (const key in obj) {
    if (obj[key] === propName) {
      delete obj[key];
    }
  }
  return obj;
};

export const pickRandomIndex = (arr, isAdvanced = false) => {
  if (!arr || !arr.length) return -1;
  if (!isAdvanced) {
    return randomInt(0, arr.length - 1);
  }
  const rnum = randomInt(0, 100);
  let temp = 0;
  const defaultWeight = Math.floor(100 / arr.length);

  const index = arr.findIndex((item) => {
    const weight = item.weight || defaultWeight;
    if (weight + temp >= rnum) return true;
    temp += weight;
    return false;
  });
  if (index < 0) return 0;
  return index;
};

export const pickRandomArr = (arr, isAdvanced = false) => {
  const index = pickRandomIndex(arr, isAdvanced);
  if (index < 0) return undefined;
  return arr[index];
};

export const isObject = (x) => {
  return typeof x === 'object' && !Array.isArray(x) && x !== null;
};

export const isWholeNumber = (num, exclude0 = false) => {
  return num % 1 === 0 && num >= 0 && (!exclude0 || num > 0);
};

export const isInteger = (num) => {
  return num % 1 === 0;
};

export const formatFloatsTo2Decimals = (obj: any, decimals = 4): any => {
  if (obj === null || obj === undefined) {
    return obj;
  }

  // Handle arrays
  if (Array.isArray(obj)) {
    return obj.map((item) => formatFloatsTo2Decimals(item));
  }

  // Handle objects
  if (typeof obj === 'object') {
    const result: any = {};
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        result[key] = formatFloatsTo2Decimals(obj[key]);
      }
    }
    return result;
  }

  // Handle numbers
  if (typeof obj === 'number') {
    // Check if the number has 5 or more decimal places
    const numStr = obj.toString();
    const decimalIndex = numStr.indexOf('.');

    if (decimalIndex !== -1) {
      const decimalPlaces = numStr.length - decimalIndex - 1;

      // Only truncate numbers with 5+ decimal places to 4 decimal places
      if (decimalPlaces > decimals) {
        return parseFloat(obj.toFixed(decimals));
      }
    }

    return obj;
  }

  // Return primitive values as-is (strings, booleans, etc.)
  return obj;
};

/**
 * Pure function that returns a new array with unique elements, removing duplicates including objects
 * @param array - The input array to process
 * @returns A new array with unique elements
 */
export const getUniqueArray = <T>(array: T[]): T[] => {
  if (!Array.isArray(array)) {
    return [];
  }

  const uniqueItems: T[] = [];
  const seenPrimitives = new Set();
  const seenObjects: T[] = [];

  for (const item of array) {
    // Handle primitive types (string, number, boolean, null, undefined)
    if (item === null || item === undefined || typeof item !== 'object') {
      if (!seenPrimitives.has(item)) {
        seenPrimitives.add(item);
        uniqueItems.push(item);
      }
    } else {
      // Handle objects and arrays by deep comparison
      const isDuplicate = seenObjects.some((seenItem) => JSON.stringify(seenItem) === JSON.stringify(item));

      if (!isDuplicate) {
        seenObjects.push(item);
        uniqueItems.push(item);
      }
    }
  }

  return uniqueItems;
};

export function deepClone<T>(obj: T): T {
  if (obj === null || typeof obj !== 'object') {
    return obj;
  }

  // Handle Date
  if (obj instanceof Date) {
    return new Date(obj.getTime()) as any;
  }

  // Handle Array
  if (Array.isArray(obj)) {
    return obj.map((item) => deepClone(item)) as any;
  }

  // Handle Map
  if (obj instanceof Map) {
    const result = new Map();
    obj.forEach((value, key) => {
      result.set(deepClone(key), deepClone(value));
    });
    return result as any;
  }

  // Handle Set
  if (obj instanceof Set) {
    const result = new Set();
    obj.forEach((item: any) => {
      result.add(deepClone(item));
    });
    return result as any;
  }

  // Handle Object
  const clonedObj: any = {};
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      clonedObj[key] = deepClone((obj as any)[key]);
    }
  }
  return clonedObj;
}

export function appendQueryParam(inputUrl, key, value) {
  const isAbsolute = /^https?:\/\//i.test(inputUrl);

  // Parse URL safely
  const baseUrl = isAbsolute ? undefined : 'http://dummy-base';
  const urlObj = new URL(inputUrl, baseUrl);

  // Normalize pathname (preserve one leading slash only)
  urlObj.pathname = urlObj.pathname
    .replace(/\/{2,}/g, '/') // collapse multiple slashes
    .replace(/^([^\/])/, '/$1'); // ensure leading slash

  // Append query param
  urlObj.searchParams.append(key, value);

  // If relative, strip dummy base
  if (!isAbsolute) {
    return urlObj.pathname + urlObj.search + urlObj.hash;
  }

  return urlObj.toString();
}
